var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotWin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0.3,1.1 1.1,0.7 14.6,25.9 13.8,26.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.8,25.9 29.2,0.5 30,1 14.6,26.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25.7,
    width: 8.1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9,30H0V0h29.9V30z M0.9,29.1H29V0.9H0.9V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9,26.6H3.7V4h22.1L25.9,26.6L25.9,26.6z M4.6,25.7h20.3V4.9H4.6V25.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotWin);
export default __webpack_public_path__ + "static/media/bot_win.58ad17e321f718dadeeb3d4040a0e215.svg";
export { ForwardRef as ReactComponent };